"use strict";
import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import _ from "underscore";
import classNames from "classnames";
import { escapeRegExp } from "../../util/strings";
import { installOcrLineDragSource } from "../ocr_line_drop";
function shouldHighlight(escapedTextToHighlight, line) {
  if (!escapedTextToHighlight) {
    return false;
  }
  return line.chars.match(escapedTextToHighlight);
}
function textLine(props, escapedTextToHighlight, line, index) {
  const className = classNames({
    "o-t": true,
    "o-h": shouldHighlight(escapedTextToHighlight, line)
  });
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: styleForLine(props, line),
      "data-chars": line.chars,
      "data-top": line.top,
      "data-left": line.left,
      "data-width": line.width,
      "data-height": line.height,
      className,
      draggable: true,
      children: "\xA0"
    },
    "text_line_" + index
  );
}
function styleForLine(props, line) {
  return {
    top: line.top * (props.imageHeight || 0),
    left: line.left * (props.imageWidth || 0),
    width: line.width * (props.imageWidth || 0) + 2,
    height: line.height * (props.imageHeight || 0) + 2
  };
}
function PageTextHighlighter(props) {
  useEffect(installOcrLineDragSource, []);
  const classes = classNames({
    "ocred-document__wrapper": true,
    "ocred-document__wrapper--enabled": true
  });
  const escapedTextToHighlight = escapeRegExp(props.textToHighlight);
  return /* @__PURE__ */ jsx("div", { "data-component": "PageTextHighlighter", className: classes, children: _.map(
    props.lines,
    (line, index) => textLine(props, escapedTextToHighlight, line, index)
  ) });
}
export default PageTextHighlighter;
